import {IHttpPromise, IHttpService} from "angular";
import {CampaignActionLog} from "../model/CampaignActionLog";
import {getAbsoluteUrl} from "../../utils/urlUtill";
import {Page} from "../../utils/models/Page";

export class CampaignActionLogService {
    static instance = [
        '$http',
        CampaignActionLogService
    ];

    constructor(private $http: IHttpService) {
    }

    fetchCustomerCampaignActionLog(customerId: number,
                                   pageNumber: number,
                                   pageSize: number): IHttpPromise<Page<CampaignActionLog>> {
        return this.$http({
            url: getAbsoluteUrl(`api/customer/${customerId}/campaign_logs`),
            method: 'GET',
            params: {
                pageNumber: pageNumber,
                pageSize: pageSize
            }
        });
    }
}